import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  default: {
    height: spacing(18),
    width: spacing(18),
  },
}))
